import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DROPDOWN_Z_INDEX = 1300;
var PORTAL_PROPS = {
  withinPortal: true,
  zIndex: DROPDOWN_Z_INDEX
};
var INPUT = {
  backgroundColor: "var(--sds-bg-base-default)",
  borderColor: "var(--sds-border-base-secondary)",
  borderRadius: 8,
  color: "var(--sds-text-base-default)",
  "&::placeholder": {
    color: "var(--sds-text-base-secondary)"
  },
  "&:focus, &:focus-within": {
    borderColor: "var(--sds-border-brand-default)"
  },
  "&:disabled, &[data-disabled]": {
    backgroundColor: "var(--sds-bg-disabled-default)",
    borderColor: "var(--sds-border-disabled-default)",
    color: "var(--sds-text-disabled-on-disabled)",
    opacity: 1,
    cursor: "not-allowed",
    "&::placeholder": {
      color: "var(--sds-text-disabled-default)"
    }
  }
};
var LABEL = {
  color: "var(--sds-text-base-default)",
  fontWeight: 600,
  marginBottom: 4
};
var REQUIRED = {
  color: "var(--sds-text-urgent-default)"
};
var WRAPPER_STYLES = {
  input: INPUT,
  label: LABEL,
  required: REQUIRED,
  description: {
    color: "var(--sds-text-base-secondary)"
  },
  error: {
    color: "var(--sds-text-urgent-default)"
  }
};
var DROPDOWN = {
  backgroundColor: "var(--sds-bg-base-default)",
  border: "1px solid var(--sds-border-base-secondary)"
};
var CONTROL_CHECKED = {
  backgroundColor: "var(--sds-bg-brand-default) !important",
  borderColor: "var(--sds-bg-brand-default) !important"
};
var CONTROL_DISABLED = {
  backgroundColor: "var(--sds-bg-disabled-default) !important",
  borderColor: "var(--sds-bg-disabled-default) !important"
};
var CONTROL_LABEL = {
  cursor: "pointer",
  color: "var(--sds-text-base-default)"
};
var CONTROL_INPUT = {
  cursor: "pointer",
  borderColor: "var(--sds-border-base-default)",
  "&:hover:not(:disabled)": {
    borderColor: "var(--sds-bg-brand-default)"
  },
  "&:checked": CONTROL_CHECKED,
  "&:checked:hover": CONTROL_CHECKED,
  "&:disabled": CONTROL_DISABLED
};
var ITEM = {
  color: "var(--sds-text-base-default)",
  "&[data-hovered]": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  "&[data-selected]": {
    "&, &:hover": {
      backgroundColor: "var(--sds-bg-brand-tertiary)",
      color: "var(--sds-text-brand-default)"
    },
    "&[data-hovered]": {
      backgroundColor: "var(--sds-bg-brand-tertiary-hover)"
    }
  }
};
var DAY = {
  color: "var(--sds-text-base-default)",
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  "&:focus": {
    outline: "none"
  },
  "&[data-outside]": {
    color: "var(--sds-text-base-tertiary)"
  },
  "&[data-weekend]": {
    color: "var(--sds-text-urgent-default)"
  },
  "&[data-selected]": {
    "&, &:hover, &:focus": {
      backgroundColor: "var(--sds-bg-brand-default)",
      color: "var(--sds-text-brand-on-brand)"
    }
  },
  "&[data-in-range]": {
    backgroundColor: "var(--sds-bg-brand-tertiary)"
  },
  "&[data-disabled]": {
    color: "var(--sds-text-disabled-default)"
  }
};
var CALENDAR_HEADER_CONTROL = {
  color: "var(--sds-text-base-default)",
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  "&:disabled, &[data-disabled]": {
    color: "var(--sds-text-disabled-default)",
    backgroundColor: "transparent"
  }
};
var CALENDAR_HEADER_LEVEL = {
  color: "var(--sds-text-base-default)",
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  }
};
var WEEKDAY = {
  color: "var(--sds-text-base-secondary)"
};
var CALENDAR_STYLES = {
  day: DAY,
  weekday: WEEKDAY,
  calendarHeaderControl: CALENDAR_HEADER_CONTROL,
  calendarHeaderLevel: CALENDAR_HEADER_LEVEL
};

/** SDS-aligned Mantine component styles applied app-wide for uniform fields and modals. */
export var MANTINE_COMPONENTS = {
  InputWrapper: {
    styles: {
      label: LABEL,
      required: REQUIRED
    }
  },
  CloseButton: {
    styles: {
      root: {
        color: "var(--sds-text-base-secondary)",
        "&:hover": {
          backgroundColor: "var(--sds-bg-base-secondary)",
          color: "var(--sds-text-base-default)"
        }
      }
    }
  },
  TextInput: {
    styles: WRAPPER_STYLES
  },
  Textarea: {
    styles: WRAPPER_STYLES
  },
  TimeInput: {
    styles: WRAPPER_STYLES
  },
  Select: {
    defaultProps: PORTAL_PROPS,
    styles: _objectSpread(_objectSpread({}, WRAPPER_STYLES), {}, {
      dropdown: DROPDOWN,
      item: ITEM
    })
  },
  MultiSelect: {
    defaultProps: PORTAL_PROPS,
    styles: _objectSpread(_objectSpread({}, WRAPPER_STYLES), {}, {
      dropdown: DROPDOWN,
      item: ITEM
    })
  },
  DatePicker: {
    defaultProps: PORTAL_PROPS,
    styles: _objectSpread(_objectSpread({}, WRAPPER_STYLES), {}, {
      dropdown: DROPDOWN
    }, CALENDAR_STYLES)
  },
  DateRangePicker: {
    defaultProps: PORTAL_PROPS,
    styles: _objectSpread(_objectSpread({}, WRAPPER_STYLES), {}, {
      dropdown: DROPDOWN
    }, CALENDAR_STYLES)
  },
  Menu: {
    defaultProps: PORTAL_PROPS,
    styles: {
      dropdown: {
        backgroundColor: "var(--sds-bg-base-default)",
        border: "1px solid var(--sds-border-base-secondary)",
        borderRadius: 12
      },
      item: {
        color: "var(--sds-text-base-default)",
        "&[data-hovered], &:hover": {
          backgroundColor: "var(--sds-bg-base-secondary)"
        }
      },
      divider: {
        borderColor: "var(--sds-border-base-secondary)"
      },
      label: {
        color: "var(--sds-text-base-secondary)"
      }
    }
  },
  Checkbox: {
    styles: {
      input: CONTROL_INPUT,
      icon: {
        color: "var(--sds-text-brand-on-brand)"
      },
      label: CONTROL_LABEL
    }
  },
  Radio: {
    styles: {
      radio: CONTROL_INPUT,
      label: CONTROL_LABEL
    }
  },
  Modal: {
    styles: {
      modal: {
        backgroundColor: "var(--sds-bg-base-default)",
        color: "var(--sds-text-base-default)",
        borderRadius: 16
      },
      title: {
        color: "var(--sds-text-base-default)",
        fontWeight: 600,
        fontSize: 18
      }
    }
  },
  Tooltip: {
    styles: {
      tooltip: {
        backgroundColor: "var(--sds-text-base-default)",
        color: "var(--sds-bg-base-default)",
        fontWeight: 500,
        fontSize: 12,
        boxShadow: "0 4px 4px -4px var(--sds-border-base-default), 0 16px 32px -4px var(--sds-border-base-default)"
      },
      arrow: {
        backgroundColor: "var(--sds-text-base-default)"
      }
    }
  }
};